<template>
  <form @submit.prevent="submitForm" id='ToBinLocation'>
    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Enter SKU
      </label>
      <input ref='skuInput' type="text" v-model="sku" class="form-control" id="input-transfer-sku" @keyup="validateSku">
      <span class='ScanError text-center' v-if="itemDataError != ''">{{itemDataError}}</span>
    </div>

    <div class="mb-3">
      <label for="scanned-skus" class="form-label">
        Scanned SKUs
      </label>
      <ul class="list-group">
        <li :class="selectedSkus.includes(item) ? 'list-group-item active' : 'list-group-item'" v-for="(item, index) in scannedSkus">
          <div class="row">
            <div :class="[item.qty > 1 ? 'col-6' : 'col-8']" class="align-self-center" @click="selectSku(item)">
              {{ item.sku }}
            </div>
            <div class="col-2 align-self-center" v-if="item.qty > 1">
              Qty {{ item.qty }}
            </div>
            <div class="col-4 text-right">
              <button type="button" class="btn btn-default btn-sm">
                View More
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item" v-if="scannedSkus.length == 0">
          Nothing scanned yet
        </li>
      </ul>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="clearSelected" :disabled="!scannedSkus.length">
          Clear Selected
        </button>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-primary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
          Clear All
        </button>
      </div>
    </div>

    <div class="mb-3">
      <label for="input-scan-bin" class="form-label">
        Scan Bin
      </label>
      <!--<input type="inputScanBin" class="form-control" id="input-scan-bin" v-model="scannedBin"> -->
      <LocationSearch 
            ref="locSearch"
            :items="searchLocations"
            name="locationSearchValue"
            store="PowerScan"
            :isAsync="true"
            id="input-scan-bin"
            classes="form-control"
            reference="locInput"
            @get-locations="getLocations"
            @key-up="setBin"
        />
    </div>

    <div class="mb-3 row">
      <div class="col-6 offset-6">
        <button type="button" class="btn btn-primary btn-sm btn-set-target-bin"  @click='setBin(scannedBin)'>
          Set Target Bin
        </button>
      </div>
    </div>
    <div class='row divider'>
        <div class='col-12'>
            <h3>Item Location</h3>
        </div>
    </div>
    <div class="card">
      <!--<div class="card-header">
        Item Location
      </div> -->
      <div class="card-body" :key='updateIndex'>
        <table class="table">
          <thead>
            <tr>
              <td>
                SKU
              </td>
              <td>
                Old Bin
              </td>
              <td>
                New Bin
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in scannedSkus" v-model='scannedSkus'>
              <td>
                {{ item.sku }}
              </td>
              <td>
                {{ item.currentLoc }}
              </td>
              <td>
                {{ item.toLoc }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
      <button type="button" class="btn btn-success w-100 btn-finalize-receipt" @click.prevent="submitForm2()" :disabled="submitDisabled"> 
        Process Transfer
      </button>
    </div>

  </form>
</template>

<script>
  import LocationSearch from './LocationSearch';
  export default {
    name: 'ToBinLocation',
    components:{
        LocationSearch
    },
    data() {
      return {
        sku : '',
        selectedSkus : [],
        foundItem: [],
        scannedSkus : [],
        inProcessTransactions : [],
        scannedBin: '',
        show: this.$store.getters['PowerScan/show'],
        singleBin: this.$store.getters['PowerScan/singleBin'],
        singleBin: this.$store.getters['PowerScan/multiBin'],
        division: this.$store.getters['PowerScan/division'],
        selectedID: this.$store.getters['PowerScan/selectedID'],
        middleware: this.$store.getters['PowerScan/middleware'],
        singleQuery: this.$store.getters['PowerScan/singleQuery'],
        multiQuery: this.$store.getters['PowerScan/multiQuery'],
        myToken: '',
        //from itemTransfer-react
        show: '',
        hidden: '', // Used with hidden input in order to determine barcode type.
        locSkuMessage: '',
        siteSkuMessage: '',
        locInputVal: '',
        receiveInputVal: '',
        locSkus: [],
        locItems: [],
        viewMoreItem: [],
        comment: '',
        binInputVal: '',
        loc_query_2: [],
        loc_query_3: [],
        itemLocationTable: [],
        newBin: '',
        locid: '',
        locTransferMessage: '',
        receiveTransferMessage: '',
        newLocInputVal: '',
        //click: Store.headerSiteClicks.length,
        showItemLocationModal: false,
        showQtyAdjuster: false,
        showQdashWarning: false,
        showNonslashWarning: false,
        toLocNumInput: '0',
        receiveNumInput: '0',
        adjusterSku: '',
        showViewMore: true,
        scrollPosition: 50,
        chosenFromLoc: '',
        chosenFromId: '',
        transfersToReceive: [],
        selectedToReceive: null,
        destination: '',
        recLocnum: '',
        recLocid: '',
        receiveSkuMessage: '',
        focused: '',
        selectTransferInputVal: '',
        showQtyLabel: false,
        item:{
            sku:'',
            qty:0,
            skuType:'',
            currentLoc:'',
            toLoc:'',
            site:'',
            locId:'',
            locNum:''
        },
        itemDataError:'',
        updateIndex: 0,
        searchLocations:[]
      }
    },
    mounted() {
      this.myToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      this.$refs.skuInput.focus();
      this.scannedSkus = this.scannedItemsForTransfer;
      //console.log('csrf', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))

    },
    computed:{
        targetBin(){
            return this.$store.getters['PowerScan/targetBin']
        },
        selectedSite(){
            return this.$store.getters['PowerScan/selectedSite'];
        },
        availableSites(){
            return this.$store.getters['PowerScan/sites'];
        },
        locationSearchValue:{
            get(){
                return this.$store.getters['PowerScan/locationSearchValue']
            },
            set(value){
                this.$store.dispatch('PowerScan/set', {field:'locationSearchValue', value: value})
            }
        },
        scannedItemsForTransfer:{
            get(){
                return this.$store.getters['PowerScan/scannedItemsForTransfer']
            },
            set(value){
                this.$store.dispatch('PowerScan/set', {field:'scannedItemsForTransfer', value: value})
            }
        },
        submitDisabled(){
            return (this.scannedSkus == [] || this.targetBin == '');
        }
    },
    methods: {
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
        this.scannedItemsForTransfer = this.scannedSkus;
      },
      selectSku(sku) {
        if ( this.selectedSkus.includes(sku) ) {
           // console.log('sku in selected?');
          this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
        } else {
          this.selectedSkus.push(sku);
          //console.log("call prep sku");
          //this._prep_sku(sku);
        }
      },
      setTargetBin(e, bin){
          this.scannedBin = bin;
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
        this.scannedItemsForTransfer = this.scannedSkus;
      },
      addSku(item) {
          //console.log('add sku - ', JSON.stringify(item) );
          //console.log('do we have a match?  -  ',  this.scannedSkus.findIndex(x => x.sku == item.sku));

        if ( item ) {
          //if ( this.scannedSkus.indexOf(item) == -1 ) { //TODO: not working ---- Appears to be working? - JM
          let checkIndex = this.scannedSkus.findIndex(x => x.sku == item.sku)
          if(checkIndex == -1){
            this.scannedSkus.push(item);
            this.scannedItemsForTransfer = this.scannedSkus;
          }else{
              //this._check_toLoc_duplicates()   // TODO: Call the function from react to check scan type once we have scan type - for now just increase Qty -JM
               if(item.sku.indexOf('/') == -1){
                   this.itemDataError = "item already scanned";
               }else{
                    this.scannedSkus[checkIndex].qty++;
                    this.scannedItemsForTransfer = this.scannedSkus;
               }
          }
        }
      },
      async validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          //console.log('Enter pressed - sku: ', this.sku)
        this.itemDataError = '';
        let fetchError = '';
        let myNotification = '';
        let myFoundItem = this.$store.dispatch('ItemCard/fetchSimpleItemInfo', {sku: this.sku, store: 'PowerScan'})
            .then((response) => {
                //console.log( 'founditem response - ' + JSON.stringify(response));
                let timeStamp = Date.now()
                let tempProduct = {
                    img : response[this.sku].Image_URL__c,
                }
                this.foundItem = tempProduct;
            });
        let ItemData = await this.getItemData(this.sku)
            .then((response) =>{
                //console.log('post-response', response);
                let currentLoc = response["bin"];
                let siteId = this.availableSites[this.availableSites.findIndex(x => x.value == response["site"])].Id;
                //console.log('itemData - ', currentLoc);
                this.item.sku = this.sku
                this.item.image = this.foundItem.img,
                this.item.qty = 1;
                this.item.currentLoc = response["bin"];
                this.item.site = response["site"];
                this.item.locId = response["locid"];
                this.item.locNum = response["locnum"];
                this.item.proj = response['proj'];
                this.item.siteId = siteId;
                this.addSku(this.item)
                this.item = {
                    sku:'',
                    qty:0,
                    skuType:'',
                    currentLoc:'',
                    toLoc:'',
                    site:'',
                    locId:'',
                    proj:'',
                    locNum:'',
                    siteId:''
                }
                setTimeout(() =>{
                    this.sku = '';
                }, 500);
            })
            .catch((error) => {
                console.log('error getting inventory data: ', error);
                this.itemDataError = 'Unable to find {'+ this.sku +'} in inventory at '+ this.selectedSite.value;
            });
          //TODO: Get SKU type - JM
          
        }
        
      },
      _check_toLoc_duplicates(){ /* ON "TO BIN/LOCATION" TAB, DETERMINE IF SCANNED SKU IS A DUPLICATE AND HANDLE BASED ON SKU TYPE.*/
        //console.log('Check Dupes');
        setTimeout(() => {
            const locItems = this.locItems
            if (locItems.length > 0) {
                let proceed = true
                const promise = new Promise((resolve, reject) => {
                    locItems.map(item => {
                        const skuMatch = item.rstk__peitem_item__c === this.locInputVal
                        const skuType = item.skuType
                        if (skuMatch && skuType === 'non-slash') {
                            this.setState({ showNonslashWarning: true })
                            proceed = false
                        } else if (skuMatch && skuType === 'qdash') {
                            this.setState({ showQdashWarning: true })
                            proceed = false
                        } else if (skuMatch && skuType === 'slash') {
                            proceed = false
                            this._increment_toLoc_qty()
                        }
                    })
                    resolve('_check_toLoc_duplicates finished')
                })
                promise.then( (message) => {
                    if (proceed) { this._query_1() }
                    proceed = true
                }).catch( (message) => { })
            } else {
                this._query_1()
            }
        }, 200)
    },
      _increment_toLoc_qty(){ /* INCREMENT QUANTITY OF ITEM ON "TO BIN/LOCATION" TAB */
        let promise = new Promise( (resolve, reject) => {
            this.setState(oldState => {
                 return {
                     locItems: oldState.locItems.map((item) => Object.assign({}, item, {
                        qty: item.rstk__peitem_item__c === this.state.locInputVal ? item.qty + 1 : item.qty,
                     }))
                 }
            })
            this.setState(oldState => {
                 return {
                     itemLocationTable: oldState.itemLocationTable.map((item) => Object.assign({}, item, {
                        qty: item.sku === this.state.locInputVal ? item.qty + 1 : item.qty,
                     }))
                 }
            })
            resolve('_increment_toLoc_qty finished')
        })
        promise.then( (message) => {
            this.setState({ locInputVal: '' })
        }).catch( (message) => { })
    },
    _query_1(){ // "TO BIN/LOCATION" TAB FUNCTION
        //Store._show_spinner()
        const query = this._return_query_string_for_view_more_item(this.locInputVal)
        const promise = new Promise( (resolve, reject) => {
            net.query(query,
                (response) => {
                    this.setState(prevState => ({
                        locSkus: [...prevState.locSkus, response.records]
                    }))
                    //this._query_2()
                    resolve('_query_1 finished')
                },
                (error) => {
                    //console.log('_query_1 error: ', error)
                    //Store._hide_spinner()
                },
            )
        })
        promise.then( (message) => {
            //console.log(message)
            //Store._hide_spinner()
        }).catch( (message) => { })
    },
      _query(){
        return new Promise((resolve, reject) => {
            //Store._show_spinner()
            let { target, notice, sku } = ''
            //this.setState({ singleQuery: [] })
            this.$store.dispatch('PowerScan/set', {field: 'singleQuery', value:[]});
            if (this.show === 'single') {
                target = 'singleQuery', notice = 'singleNotice', sku = 'singleSkuVal'
            } else {
                target = 'multiQuery', notice = 'multiNotice', sku = 'multiSkuVal'
            }
            const query = `SELECT rstk__externalid__c, rstk__iclocitem_site__r.rstk__externalid__c, rstk__iclocitem_proj__c, rstk__iclocitem_site__c FROM rstk__iclocitem__c WHERE rstk__iclocitem_icitem__r.rstk__externalid__c = '${this.division}_${this.sku}'`
            net.query(query,
                (response) => {
                    const recs = response.records
                    let proceed = false
                    if (recs.length > 0) {
                        recs.map(item => {
                            if (item.rstk__iclocitem_site__r.rstk__externalid__c === `${config.division}_${Store.selectedSite}`) {
                                proceed = true
                            }
                        })
                    }
                    if (proceed) {
                        this.setState(prevState => ({
                            [target]: [...prevState[target], response.records[0]]
                        }))
                        this.setState({ [notice]: '' })
                        resolve('item site verified')
                    }else{
                        reject('Item is not currently located in your selected site.')
                    }
                },
                (error) => {
                    reject('_query error: ' + error)
                },
            )
        })


        promise.then((message) => {
            //console.log(message)
            //console.log('[target]', this.state[target])
        })
    },
    _find_if_in_transaction(){
        return new Promise((resolve, reject) => {
            let error = false
            const store = this.inProcessTransactions
            const variables = this.$store.dispatch('PowerScan/_return_tab_variables');
            //console.log('find in transaction variables - ', JSON.stringify(variables));
            if (store.length > 0) {
                store.map((transaction, index) => {
                    if (transaction.transactionType === 'InventoryTransfer') {
                        transaction.items.map(item => {
                            if (item.params.item === this.state[variables.sku]) {

                                reject('SKU IS ALREADY IN TRANSACTION!')
                            }
                        })
                    }
                })
            }
            resolve('sku not in active transaction')
        })
    },
    _add_sku_to_state_item(){
        return new Promise((resolve, reject) => {
            let { target, sku } = ''
            const show = this.show
            if (show === 'single') {
                target = 'singleQuery', sku = 'singleSkuVal'
            } else {
                target = 'multiQuery', sku = 'multiSkuVal'
            }
            //let newArray = this.[`${target}`];
            let newArray = this.[target];
            //console.log('target: ', target, ', newArray - ', newArray, ', length: ', newArray[newArray.length]);
            newArray[newArray.length - 1]['sku'] = sku;
            this.setState({ [target]: newArray })
            resolve('sku added to state')
        })
        .catch((error) => {
            console.log('error: ', error)
        });
    },
     async _prep_sku(item){
        //Store._show_spinner()
        let fetchError = '';
        let myNotification = '';
        this.$store.dispatch('Navigation/addPendingNotification',{
                    icon: 'SearchIcon',
                    header: 'Item Search',
                    message: 'Get Data for: ' + item.sku,
                    type: (fetchError == '') ? 'success' : fetchError
        }).then((response) => {
            myNotification = response;

        });
            let ItemHistory = await this.getHistory(item.sku)
                .then((response) =>{
                    //console.log('post-response', response);
                    //this.item.currentLoc = response[response.length-1].to;
                    //this.addFinalNotification(item.sku, fetchError, myNotification);
                })
                .catch((error) => {
                    console.log('error: ',error);
                });
        //this.$store.dispatch('ItemCard/fetchItemHistory', item.sku);
       // this.$store.dispatch('ItemCard/fetchOfferInventoryData', item.sku)
            let ItemData = await this.getItemData(item.sku)
                .then((response) =>{
                    //console.log('post-response', response);
                    item.currentLoc = response["bin"];
                    //console.log('itemData - ', item.currentLoc);
                    //this.addFinalNotification(item.sku, fetchError, myNotification);
                })
                .catch((error) => {
                    console.log('error getting inventory data: ', error);
                    
                });
         await this._find_if_in_transaction()
            .then((response) => {
                //console.log('prep-sku: find in transaction return: ', response);
                this.$store.dispatch('PowerScan/_query')
            })
            //.then((message) => this._query())
            .then((response) => { 
                //console.log('back from query - '+ response)
                this._add_sku_to_state_item()
            })
            .then((message) => {
                if (this.show === 'single')  this._exec_putaway() // this continues on to actually post the transcation
                else                    this._add_params_to_multi_skus() // this stores the processed information in state for the multiple sku put away later
            })
            .catch((message) => {
               // Store._hide_spinner()
                //this.setState({ [notice]: message })
                this.$store.dispatch('PowerScan/set', {field: 'notice',value: message});
            })
    },
    async getHistory(sku){
        let ItemHistory = await this.$store.dispatch('ItemCard/fetchItemHistory', sku);
       // console.log('what about this? - ', ItemHistory);
        return ItemHistory;
    },
    async getItemData(sku){
        let ItemData = await this.$store.dispatch('ItemCard/fetchOfferInventoryData', sku);
       // console.log('what about this data? - ', ItemData);
        return ItemData;
    },
    _add_params_to_multi_skus(){
        let newArray = this.state.multiQuery
        let len = newArray.length - 1
        newArray[len]['selected'] = false
        newArray[len]['key'] = Math.random().toFixed(10)
        this.setState({ multiQuery: newArray })
        this.setState({ multiSkuVal: '' })
        //Store._hide_spinner()
    },
    async submitForm2(){
        const topLevel = this;
        let fetchError = '';
        const response = await this.$store.dispatch('PowerScan/_setup_post_array', this.scannedSkus);
        //console.log('from setup_post_array - response: ', response);
        await this.$store.dispatch('PowerScan/_post', {token: this.token, postArray:response})
            response.forEach((data) => {
                //console.log('checking data - ' + JSON.stringify(data));
                let myNotification = '';
                this.$store.dispatch('Navigation/addPendingNotification',{
                    icon: 'ItemTransfersIcon',
                    header: 'Transfer Item',
                    message: data.name,
                    type: 'pending...',
                    reference: data.id,
                    product: data.product,
                    transactionType: 'Transfer',
                    status: 'pending'

                }).then((response) => {
                    myNotification = response;

                }).then(() => {
                    getData(data);
                    function getData(data){
                        topLevel.$store.dispatch('PowerScan/_checkTransfer', {reqID: data.req_ref, id: data.id})
                            .then((response) =>{
                                if (response.data.status == 'ready' || response.data.status == 'prepared'){
                                    setTimeout(getData, 5000, data)
                                }else{
                                    //console.log('done?' + JSON.stringify(response.data));
                                    let status = response.data.response ? response.data.response : 'success'
                                    let myIcon = response.data.status == 'error' ? 'NotificationError' : myNotification.icon
                                    topLevel.$store.dispatch('Navigation/addNotification',{
                                        icon: myIcon,
                                        header: myNotification.header,
                                        message: myNotification.message,
                                        type: status,
                                        product: myNotification.product,
                                        transactionType: myNotification.transactionType,
                                        reference: response.data.id,
                                        status: status
                                    });
                                    topLevel.$store.dispatch('Navigation/removePendingNotification', myNotification);
                                }
                            });
                    };
                    this.clearAll();
                });
            })
           // console.log('post-response', response);

    },
    addFinalNotification(value, fetchError, pendingNotification){
        this.$store.dispatch('Navigation/addNotification',{
            icon: pendingNotification.icon,
            header: pendingNotification.header,
            message: pendingNotification.message,
            type: fetchError == '' ? pendingNotification.type : fetchError
        });
        this.$store.dispatch('Navigation/removePendingNotification', pendingNotification);
    },

    _return_query_string_for_view_more_item(sku){ // QUERY FOR ADDING DATA TO "VIEW MORE" MODAL.
        return `SELECT WGACA_Waybill__c, rstk__peitem_item__c, rstk__peitem_descr__c, WGACA_Image_URL__c FROM rstk__peitem__c WHERE rstk__peitem_item__c = '${ sku }'`
    },
    _exec_transfer(){
        this._transfer_setup()
            .then(message => this._setup_to_bin_post_array())
            .then(posts => _post(posts))
            .then(jsons => _parse_post_return(jsons, 'InventoryTransfer'))
            .then(parsed => {
                //Store._add_in_process_transactions(parsed)
                this.setState({ locTransferMessage: "SAVE IN PROCESS" })
                this._reset_transfer_messages()
                this._clear_all()
                //Store._hide_spinner()
        })
    },
    
    /*doCapture() {
        var self = this;
        this.startProgress();
        captureOrder({ recordId: this.recordId }).then(function (r) {

            if (r != null && r.length == 18) {
                self.handleJobStatusUpdate(r, () => {
                    console.log("marking order captured");
                    markOrderCaptured({orderSummaryId : self.order.OrderSummaryId});
                    console.log("order marked");
                    self.stopProgress();
                    self.displaySuccess('Payment captured!');
                }, "Capture failed.  DO NOT ship this order yet. ");
            } else if (r == 'captured') {
                markOrderCaptured({orderSummaryId : self.order.OrderSummaryId});
                self.stopProgress();
                self.displaySuccess('Payment already captured.');
            } else {
                self.displayError("Capture failed.  DO NOT ship this order yet.  Please double check payment details and try again.");
                self.stopProgress();
            }
        }).catch(function (e) {
            console.log("ERROR FOLLOWS");
            console.log(e);
            if (e.message) {
                self.displayError("Capture failed.  DO NOT ship this order yet. " + e.message);
            } else if (e.body && e.body.message) {
                self.displayError("Capture failed.  DO NOT ship this order yet. " + e.body.message);
            } else {
                self.displayError("Capture failed.  DO NOT ship this order yet. " + e);
            }
            self.stopProgress();
            });
        },*/
        submitForm() {
            const {
            sku,
            scannedSkus
            } = this
            //console.log('sku - ', sku );
            //console.log('scannedSkus - ', scannedSkus);
            //this.$api.post('jimiv2-steve.wgaca-works.com', {
            this.$api.post('/api/power-scan/transfer-items-to-bin-location', {
            //_token : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            sku,
            scannedSkus
            }).then((response) => {
            //console.log('Roman:', response)
            }).catch((error) => {
                //console.log('Error - ', error)
            });

        },
        setBin(e, bin){
            bin = bin ? bin : this.locationSearchValue
            //console.log('bin = '+ bin);
            let splitBin = this.locationSearchValue.split('_');
            let toLocId = splitBin[0];
            let toLocNum = splitBin[1];
            this.$store.dispatch('PowerScan/set', {field: 'targetBin', value: this.locationSearchValue})
            .then(() => {
                if (this.selectedSkus.length > 0) {
                    this.selectedSkus.map((item) => {
                        item.toLoc = bin;
                        this.scannedSkus[this.scannedSkus.findIndex(x => x.sku == item.sku)].toLocId = toLocId;
                        this.scannedSkus[this.scannedSkus.findIndex(x => x.sku == item.sku)].toLocNum = toLocNum;
                        this.scannedSkus[this.scannedSkus.findIndex(x => x.sku == item.sku)].toLoc = bin;
                        this.updateIndex++
                    });
                }else{
                    for(let i=0; i < this.scannedSkus.length; i++){
                        this.scannedSkus[i].toLoc = bin;
                        this.scannedSkus[i].toLocId = toLocId;
                        this.scannedSkus[i].toLocNum = toLocNum;
                    }
                    this.updateIndex++;
                }
            });
        },
        async getLocations(search){
            let locationsFromSearch = await this.$store.dispatch('PowerScan/fetchCurrentLocations', search);
            this.searchLocations = locationsFromSearch;
        }
    },
  }
</script>
